import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./pages/Layout";
import Home from "./pages/Home/Home";
import HIVE from "./pages/Projects/HIVE/hive";
import MK2 from "./pages/Projects/MK2/mk2";
import ATMOS from "./pages/Projects/ATMOS/atmos";
import VSC from "./pages/Projects/VSC/vsc";
import PortableHood from "./pages/Projects/PortableHood/portablehood";
import AdditionalProject from "./pages/Projects/AdditionalProject/additionalproject";
import Contact from "./pages/Home/Components/Contact/contact";
import NoPage from "./pages/NoPage";
import "@fontsource/hanken-grotesk/400.css";
import "@fontsource/hanken-grotesk/500.css";
import "@fontsource/hanken-grotesk/700.css";
import "@fontsource/hanken-grotesk/800.css";
import "@fontsource/ibm-plex-mono/400.css";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/hive" element={<HIVE />} />
          <Route path="/mk2" element={<MK2 />} />
          <Route path="/atmos" element={<ATMOS />} />
          <Route path="/vsc" element={<VSC />} />
          <Route path="/portablehood" element={<PortableHood />} />
          <Route path="/additionalproject" element={<AdditionalProject />} />
          <Route path="/contact" element={<Contact headingLevel={1} />} />
          <Route path="*" element={<NoPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
